export function getAccessTokenUsecaseFactory(deps) {
    return async () => {
        const isAuthenticated = await deps.authRepository.isAuthenticated();
        if (isAuthenticated) {
            try {
                const userAuth0Token = await deps.authRepository.getUserAuth0Token();
                return userAuth0Token?.accessToken || null;
            }
            catch (auth0Error) {
                // eslint-disable-next-line no-console
                console.warn(`GetAccessTokenUsecase : this case should not happen - Auth0 Error : ${auth0Error.error}`);
                return null;
            }
        }
        return null;
    };
}
//# sourceMappingURL=get-access-token.usecase.js.map